import { openDB } from "idb";

import { ensureArray } from "@app/service/helpers";
import { CONST_IDB_VERSION } from "@app/state/constants";
import { schemaB } from "@app/stateCommon/schemaBlue"; /// (!!!)
import { isTBlueTable } from "@app/statefx/routines/mapperfn";
import { initialState } from "@app/statefx/schema";

export type TWIDBStore = typeof initialState & {
  hashes: {
    [key: string]: string;
  };
  metadata: {
    key: string;
    value: any;
  };
  persist: {
    key: string;
    value: any;
  };
};

const totalRenewVersionId = 72;
export const db = (store) =>
  openDB(store, CONST_IDB_VERSION, {
    upgrade(db, oldVersion, newVersion) {
      if (oldVersion < totalRenewVersionId) {
        if (db.objectStoreNames.contains("hashes")) {
          db.deleteObjectStore("hashes");
        }
        if (db.objectStoreNames.contains("mywork")) {
          db.deleteObjectStore("mywork");
        }
        if (db.objectStoreNames.contains("invoiceFiscal")) {
          db.deleteObjectStore("invoiceFiscal");
        }
        if (db.objectStoreNames.contains("invoiceIssuer")) {
          db.deleteObjectStore("invoiceIssuer");
        }
        if (db.objectStoreNames.contains("issuerBankAccounts")) {
          db.deleteObjectStore("issuerBankAccounts");
        }
        if (db.objectStoreNames.contains("SPVMessages")) {
          db.deleteObjectStore("SPVMessages");
        }
        if (db.objectStoreNames.contains("SPVMessageKeys")) {
          db.deleteObjectStore("SPVMessageKeys");
        }
        if (db.objectStoreNames.contains("SPVInvoiceRaw")) {
          db.deleteObjectStore("SPVInvoiceRaw");
        }
        if (db.objectStoreNames.contains("SPVMessageUserState")) {
          db.deleteObjectStore("SPVMessageUserState");
        }
        if (db.objectStoreNames.contains("fileSysContent")) {
          db.deleteObjectStore("fileSysContent");
        }
        if (db.objectStoreNames.contains("fileSysHead")) {
          db.deleteObjectStore("fileSysHead");
        }
        if (db.objectStoreNames.contains("fsDirTree")) {
          db.deleteObjectStore("fsDirTree");
        }
        if (db.objectStoreNames.contains("fileSysLocalDisk")) {
          db.deleteObjectStore("fileSysLocalDisk");
        }
        if (db.objectStoreNames.contains("fiscalBooks")) {
          db.deleteObjectStore("fiscalBooks");
        }
        if (db.objectStoreNames.contains("contractors_cff")) {
          db.deleteObjectStore("contractors_cff");
        }
        if (db.objectStoreNames.contains("contractors_temp")) {
          db.deleteObjectStore("contractors_temp");
        }
        if (db.objectStoreNames.contains("contactlist")) {
          db.deleteObjectStore("contactlist");
        }
        if (db.objectStoreNames.contains("receiptFiscal")) {
          db.deleteObjectStore("receiptFiscal");
        }
        if (db.objectStoreNames.contains("invoiceCollection")) {
          db.deleteObjectStore("invoiceCollection");
        }
      }
      /* -------------------------------------------------------------------------- */
      // custom migrations //
      if (oldVersion <= 72) {
        if (db.objectStoreNames.contains("contractors_cff")) {
          db.deleteObjectStore("contractors_cff");
        }
        if (db.objectStoreNames.contains("contractors_temp")) {
          db.deleteObjectStore("contractors_temp");
        }
      }

      /* -------------------------------------------------------------------------- */
      // the old name, not used anymore, avoiding confusion (!)
      if (db.objectStoreNames.contains("spvmessages")) {
        db.deleteObjectStore("spvmessages");
      }
      // the old name, not used anymore, avoiding confusion (!)
      if (db.objectStoreNames.contains("extrates")) {
        db.deleteObjectStore("exrates");
      }
      /* -------------------------------------------------------------------------- */
      // common
      if (!db.objectStoreNames.contains("whoami")) {
        db.createObjectStore("whoami");
      }
      if (!db.objectStoreNames.contains("currencies")) {
        db.createObjectStore("currencies");
      }
      if (!db.objectStoreNames.contains("hashes")) {
        db.createObjectStore("hashes");
      }
      //saga-query related
      if (!db.objectStoreNames.contains("metadata")) {
        db.createObjectStore("metadata");
      }
      if (!db.objectStoreNames.contains("mywork")) {
        const work = db.createObjectStore("mywork", { keyPath: "id" });
        if (!work.indexNames.contains("byHash")) {
          work.createIndex("byHash", ["_hkey", "_hvalue"]);
        }
        //myworkBySQLDate
        if (!work.indexNames.contains("myworkBySQLDate")) {
          work.createIndex("myworkBySQLDate", "DATA_SQL");
        }
        //myworkByUnixDate
        if (!work.indexNames.contains("myworkByUnixDate")) {
          work.createIndex("myworkByUnixDate", "DATA_UNIX");
        }
      }
      /// THE DATABASE

      for (const [key, value] of Object.entries(schemaB)) {
        if (value.idb) {
          if (!db.objectStoreNames.contains(key)) {
            try {
              if (isTBlueTable(value)) {
                const t = db.createObjectStore(key, {
                  keyPath: value.primaryKey as string,
                });
                // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
                //if index with name  "byHash" doesn't exists
                if (!t.indexNames.contains("byHash")) {
                  t.createIndex("byHash", ["_hkey", "_hvalue"]);
                }
                //if index with name  "shid0" doesn't exists
                if (!t.indexNames.contains("shid0")) {
                  t.createIndex("shid0", "shid0");
                }
                //if index with name  "shid1" doesn't exists
                if (!t.indexNames.contains("shid1")) {
                  t.createIndex("shid1", "shid1");
                }

                if (value.idb_indexes) {
                  for (const index of ensureArray(value?.idb_indexes)) {
                    t.createIndex(
                      index.name,
                      index.keyPath as string | string[]
                    );
                  }
                }
              } else {
                db.createObjectStore(key);
              }
            } catch (error) {
              console.error("error creating object store", key, error);
              continue;
            }
          }
        }
      }
    },
    blocked(currentVersion, blockedVersion, event) {
      console.log("blocked", currentVersion, blockedVersion, event);
    },
    blocking(currentVersion, blockingVersion, event) {
      console.log("blocking", currentVersion, blockingVersion, event);
    },
    terminated() {
      console.log("terminated");
    },
  });
